import { database, storage } from "./firebase";
import { snapshot2List } from "./utils";

const imagesTable = "images";
const imagesRef = database.ref(imagesTable);

const _images = [
  "bich_hut_chan_khong.jpg",
  "daklak.png",
  "dau_100.jpg",
  "dau_300.jpg",
  "hop_giay.jpg",
  "maca_2.jpg",
  "maca_3.jpg",
  "maca_5.jpg",
  "maca_6.jpg",
  "maca_8.jpg",
  "maca_9.jpg",
  "maca_10.jpg",
  "maca_12.jpg",
  "maca_13.jpg",
  "maca_14.jpg",
  "maca_15.jpg",
  "maca_18.jpg",
  "maca_19.jpg",
  "maca_cake.jpg",
  "maca_cookies.jpg",
  "maca_flowers_2.jpg",
  "maca_leaves.jpg",
  "maca_nuts_16.jpg",
  "maca_nuts_half_open.jpg",
  "maca_pasta.jpg",
  "maca_pumpkin_soup.png",
  "maca_salad.jpg",
  "maca_seedlings.jpg",
  "maca_tofu_2.jpg",
  "maca_tofu.jpg",
  "maca_yoghurt_2.jpg",
  "nhan_kho_sua.jpg",
  "nhan_say_sua.jpg",
]
  .map((image) => {
    try {
      return {
        name: image,
        url: require("../../public/images/" + image).default,
      };
    } catch (e) {}
  })
  .filter((x) => x);

export function initImages() {
  return Promise.all(
    _images.map((image) => {
      return fetch(image.url)
        .then(function (response) {
          return response.blob();
        })
        .then((blob) => {
          return storage.ref("images/" + image.name).put(blob);
        })
        .then((snapshot) => {
          return snapshot.ref.getDownloadURL();
        })
        .then((url) => {
          return {
            name: image.name,
            url: url,
          };
          // console.log('image url', url )
        });
    })
  ).then((images) => {
    let data = {};
    for (let image of images) {
      data[imagesRef.push().key] = image;
    }
    return imagesRef.set(data);
  });
}
window.initImages = initImages;

export function getImages() {
  return new Promise((success, fail) => {
    imagesRef.once(
      "value",
      (snapshot) => {
        success(snapshot2List(snapshot));
      },
      fail
    );
  });
}

export function addImage(image) {
  return storage
    .ref(`images/${image.name}`)
    .put(image)
    .then((snapshot) => {
      return snapshot.ref.getDownloadURL();
    })
    .then((url) => {
      return {
        name: image.name,
        url: url,
      };
    })
    .then((image) => {
      return imagesRef
        .child(imagesRef.push().key)
        .set(image)
        .then(() => image);
    });
}
